import { Switch, Route, BrowserRouter as Router  } from 'react-router-dom';
import React from 'react';

// Containers
const Layout = React.lazy(() => import('../shared/Layout'));
// Pages
const Login = React.lazy(() => import('../pages/authentication/Login'));
const PageNotFound = React.lazy(() => import('../components/common/error/PageNotFound'));
const SomeThingWentWrong = React.lazy(() => import('../pages/error/SomeThingWentWrong'));

//Spinner
const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

const LayoutNavigation=(props)=>{
    return (
        <Router>
            <React.Suspense fallback={loading}>
                <Switch>
                    <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
                    <Route path="/" name="Layout" render={props => <Layout {...props} />} />
                    <Route exact path="/404" name="Page Not Found" render={props => <PageNotFound {...props} />} />
                    <Route path="/SomeThingWentWrong" name="SomeThingWentWrong" render={props => <SomeThingWentWrong {...props} />} />
                </Switch>
            </React.Suspense>
        </Router>
    );
}


export default LayoutNavigation;
